import api from 'common/api';

export const getFilterBLInformationAPI = (params: any) => api.get('/bl-information-export/search', params);

export const getDetailCargoInfoAPI = (params: any) => api.get('/cargo-information-export/detail', params);

export const updateCargoInfoAPI = (params: any) => api.put('/cargo-information-export', params);

export const deleteCargoInfoAPI = (params: any) => api.put('/cargo-information-export/delete-bl', params);

export const addCargoInfoAPI = (params: any) => api.post('/cargo-information-export', params);
